module.exports = __webpack_public_path__ + "img/check-icon-primary.cc73c406.svg";